<template>
  <div>
    <div class="slide-proportion-2-3">
      <div class="left-block-positioner">
        <h1 class="slide-header">ФАКТ 3</h1>
        <p class="tagline">
          Імператорські пінгвіни – однолюби. Протягом усього життя вони
          дотримуються однієї пари та арктичного дизеля на ОККО, який не
          замерзає до мінус сорока.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact3/Left.vue